import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { useCart } from './CartContext';
type Variante = {
  label: string;
  precio: string;
  shopifyVariantId: number;
  imagen?: string;
};
export type Producto = {
  coleccion: string;
  nombre: string;
  notas: string;
  descripcion: string;
  tags: string[];
  gramaje: string;
  variantes: Variante[];
};
type ProductoCardProps = {
  producto: Producto;
  delay?: number;
};
export function ProductoCard({
  producto,
  delay = 1
}: ProductoCardProps) {
  const [active, setActive] = useState(0);
  const {
    addItem
  } = useCart();
  const variante = producto.variantes[active];
  const handleAdd = () => {
    addItem({
      variantId: variante.shopifyVariantId,
      name: producto.nombre,
      aroma: producto.notas,
      format: variante.label,
      price: parseCopPrice(variante.precio),
      image: variante.imagen
    });
  };
  return <div className={`product-card reveal d${delay}`} data-id="element-192" data-mp="29vu24djyz4fj">
      <div className="product-card__image" data-id="element-193" data-mp="29xex24a74pdx">
        {variante.imagen ? <img src={variante.imagen} alt={`${producto.nombre} SAVIA, vela ${variante.label.toLowerCase()}`} data-id="element-194" data-mp="eyzsa9v8y9pj" /> : <div className="product-card__placeholder" aria-label={`Imagen de ${producto.nombre} próximamente`} role="img" data-id="element-195" data-mp="nymomh94cpbq" />}
      </div>
      <div className="product-card__info" data-id="element-196" data-mp="sr61td3w9ig0">
        <p className="product-card__coleccion" data-id="element-197" data-mp="xnd1wp9lzzq1">{producto.coleccion}</p>
        <h3 className="product-card__nombre" data-id="element-198" data-mp="12n97gsxyfz7p">{producto.nombre}</h3>
        <p className="product-card__notas" data-id="element-199" data-mp="12plxltdv9fvu">{producto.notas}</p>
        <div className="product-card__variantes" aria-label="Formato de vela" data-id="element-200" data-mp="17nngoebalf7b">
          {producto.variantes.map((variant, index) => <button key={variant.label} type="button" className={`variante-btn ${index === active ? 'activa' : ''}`} onClick={() => setActive(index)} aria-pressed={index === active} data-id="element-201" data-mp="1bm37yueep9qj" data-mpi={index}>
              {variant.label}
            </button>)}
        </div>
        <div className="product-card__footer" data-id="element-202" data-mp="fmisr4i9hs4d">
          <span className="product-card__precio" data-id="element-203" data-mp="fntvr23vuvuf">{variante.precio} COP</span>
          <button type="button" className="product-card__cta" onClick={handleAdd} aria-label={`Agregar ${producto.nombre}, ${variante.label}, al carrito`} data-id="element-204" data-mp="tmjoy6nl0bdi">
            Agregar
            <PlusIcon size={13} strokeWidth={1.5} aria-hidden="true" data-id="element-205" data-mp="13hle32huxdg3" />
          </button>
        </div>
      </div>
    </div>;
}
function parseCopPrice(price: string) {
  return Number(price.replace(/[^0-9]/g, ''));
}